var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgR6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 427,
    height: 48,
    viewBox: "0 0 427 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.272 47.5513H535.51V45.458H340.272C337.212 45.4654 334.181 44.8686 331.354 43.702C328.527 42.5354 325.96 40.8222 323.802 38.6616L294.41 9.39321C292.053 7.03716 289.249 5.17047 286.162 3.90138C283.075 2.6323 279.766 1.98609 276.426 2.00023H3.00017V4.09357H276.426C279.487 4.08516 282.518 4.68155 285.345 5.8482C288.172 7.01484 290.739 8.72852 292.896 10.8899L322.289 40.1548C324.645 42.5115 327.448 44.3789 330.535 45.6486C333.622 46.9182 336.932 47.565 340.272 47.5513V47.5513Z",
    fill: "url(#paint0_linear_164_14504)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.497 6.96384C1.56557 6.96384 -0.000146866 5.40493 -0.000146866 3.48192C-0.000146866 1.55891 1.56557 0 3.497 0C5.42842 0 6.99414 1.55891 6.99414 3.48192C6.99414 5.40493 5.42842 6.96384 3.497 6.96384Z",
    fill: "url(#paint1_linear_164_14504)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_164_14504",
    x1: 168.249,
    y1: 24.7688,
    x2: 601.917,
    y2: 24.7688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4D0D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_164_14504",
    x1: -7323.44,
    y1: 69.4994,
    x2: 1332.55,
    y2: 69.4994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgR6);
export default __webpack_public_path__ + "static/media/r6.1220d0df0c080338c92f35efe0efe07b.svg";
export { ForwardRef as ReactComponent };